
function idYear(y) {
    const current = new Date().getFullYear() - 2000;
    const century = y < current ? 2000 : 1900;
    return y + century;
}

export default function(val) {
     // http://geekswithblogs.net/willemf/archive/2005/10/30/58561.aspx
    // A South African ID number is a 13-digit number which is defined by the following format: YYMMDDSSSSCAZ.
    // The first 6 digits (YYMMDD) are based on your date of birth. 
    // 20 February 1992 is displayed as 920220.
    // SSSS are used to define your gender. Females 0000-4999 and males from 5000-9999.
    // C shows if you're an SA citizen status with 0 denoting that you were born a SA citizen and 1 denoting that you're a permanent resident.
    // A - 08 / 09. Don't know can be other
    // The last digit (Z) is a checksum digit – used to check that the number sequence is accurate  using a set formula called the Luhn algorithm.
    
    if (val == null) return false
    
    // Make sure to convert to string
    val = val.toString()
    if (!val || val.length != 13)  {
        return false
    }

    let year = val.substr(0, 2)
    let month = val.substr(2, 2)
    let day = val.substr(4, 2)
    
    let ssss = val.substr(6, 4)
    let c = val[10]
    let a = val[11]
    let z = val[12]

    let digits = val.split('').map(d => parseInt(d))
    let mm = 10 * digits[2] + digits[3]
    if (mm == 0 || mm > 12) {
        // invalid month
        return false
    }

    let dd = 10 * digits[4] + digits[5]
    if (dd == 0 || dd > 31) {
        // invalid day
        return false
    }
    // let ssss = 
    // check digit
    // a = Add all the digits in the odd positions (excluding last digit).
    // b = Move the even positions into a field and multiply the number by 2.
    let ai = 0
    let bi = 0
    for(let i = 0; i < 6; i++) {
        ai += digits[2*i]
        bi = bi * 10 + digits[2*i+1]
    }
    
    // Add the digits of the result in b).
    bi = (bi*2).toString().split('').reduce((acc, val) => parseInt(acc) + parseInt(val))
    
    // Add the answer in [2] to the answer in [1].
    let add = ai + bi;
    let d = 10 - (add % 10);
    if (d == 10) d = 0;

    return {
        valid: z == d,
        year: idYear(parseInt(year)),
        month: parseInt(month),
        day: parseInt(day),
        gender: ssss <= 4999 ? 'female' : 'male',
        citizen: c == 0,
        checksum: d
    }
}